import { initGraphQLTada } from 'gql.tada';
import type { introspection } from './graphql-env.js';
import { GQLScalarTypes } from '@/helpers/gql-scalar-types.js';

export const gql = initGraphQLTada<{
  introspection: introspection;
  disableMasking: true;
  scalars: GQLScalarTypes;
}>();
